import { Expose, Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class InvoiceSummaryDto {
  @Expose()
  overdueCount: number;

  @Expose()
  @Transform(({ value }) => toEuros(value))
  pendingCollectionGroupAmount: number;

  @Expose()
  @Transform(({ value }) => toEuros(value))
  pendingCollectionNonGroupAmount: number;

  @Expose()
  @Transform(({ value }) => toEuros(value))
  readyForBillingAmount: number;
}
